export default class StoreManager {
    static userdata = {
        token: '',
        jwtDecode:{}
    }
    static appdata = {
        
    }
    static rootState = {
    }
    static async loadDataFromLocal(){
       var data = localStorage.getItem("userdata_truonguy")
       if (data) {
        this.userdata = JSON.parse(data)
       }
       console.log("this.userdata", this.userdata)
    }
    static updateDataToLocal() {
        localStorage.setItem("userdata_truonguy", JSON.stringify(this.userdata))
    }
}